import React, { createContext, useContext, useState } from "react";

export const VendorMgmtContext = createContext({
  globalFilter: {
    searchMode: "single",
    singleSearchType: "vendorSapCode",
    singleSearchValue: "",
    vendorType: [],
    bu: [],
    accountStatus: [],
  },
  setGlobalFilter: () => {},
});

export const useVendorMgmtContext = () => {
  return useContext(VendorMgmtContext);
};

export const VendorMgmtProvider = ({ children, ...props }) => {
  const [globalFilter, setGlobalFilter] = useState({
    searchMode: "single",
    singleSearchType: "vendorSapCode",
    singleSearchValue: "",
    vendorType: [],
    bu: [],
    accountStatus: [],
  });

  return (
    <VendorMgmtContext.Provider
      value={{
        globalFilter,
        setGlobalFilter,
        ...props,
      }}
    >
      {children}
    </VendorMgmtContext.Provider>
  );
};
